import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { logout } from 'src/app/store/auth/auth.actions';
import { IGlimpseReport } from 'src/app/modules/customer-shared/models/IGlimpseReport';
import { ReportCardLayout } from 'src/app/modules/customer-shared/models/ReportCardLayout';
import * as fromActions from './audits.actions';

export interface AuditsState {
  reports: {
    [locationId: number]: IGlimpseReport[] | null;
  };
  loadingLocations: number[];
  layout: ReportCardLayout;
}

export const initialAuditsState: AuditsState = {
  reports: {},
  loadingLocations: [],
  layout: 'minimal',
};

const reducer = createReducer(
  initialAuditsState,
  on(fromActions.changeLayout, (state, { layout }) => (state = { ...state, layout })),
  on(
    fromActions.loadReports,
    (state, { locationId }) =>
      (state = {
        ...state,
        loadingLocations: [...state.loadingLocations, locationId],
      }),
  ),
  on(
    fromActions.loadReportsSuccess,
    (state, { latestReports, locationId }) =>
      (state = {
        ...state,
        reports: {
          ...state.reports,
          [locationId]: latestReports,
        },
        loadingLocations: state.loadingLocations.filter(lId => lId != locationId),
      }),
  ),
);

export function auditsReducer(state: AuditsState | undefined, action: Action) {
  return reducer(state, action);
}
